export default {
  INCH: "inch",
  CM: "cm",
} as const;
